import { render, staticRenderFns } from "./restartCases.vue?vue&type=template&id=5bfa697e&scoped=true"
import script from "./restartCases.vue?vue&type=script&lang=js"
export * from "./restartCases.vue?vue&type=script&lang=js"
import style0 from "./restartCases.vue?vue&type=style&index=0&id=5bfa697e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa697e",
  null
  
)

export default component.exports